import React from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'

import Ribbon from 'components/Ribbon'

storiesOf('Ribbon', module)
  .add('default', () => (
    <Grid direction="column" alignItems="center" spacing={2} container>
      <Grid item>
        <Ribbon />
      </Grid>
      <Grid item>
        <Ribbon color="nile" />
      </Grid>
      <Grid item>
        <Ribbon text="contest" />
      </Grid>
      <Grid item>
        <Ribbon text="contest" color="nile" />
      </Grid>
      <Grid item>
        <Ribbon text="long text with many words" />
      </Grid>
      <Grid item>
        <Ribbon text="long text with many words" color="nile" />
      </Grid>
    </Grid>
  ))
